import { Component, ElementRef, input, viewChild } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { NgStyle } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export type TTooltipChartsItem = {
  label?: string;
  value?: number | string;
  color?: string;
  iconLeft?: string;
  iconRight?: string;
}
@Component({
  selector: 'lib-tooltip-charts',
  imports: [NgStyle, TranslateModule],
  templateUrl: './tooltip-charts.component.html',
  styleUrl: './tooltip-charts.component.css',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('200ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class TooltipChartsComponent {

  /**
   * Reference to the tooltip element
   */
  public readonly tooltipRef = viewChild<ElementRef<HTMLElement>>('tooltipRef');
  /**
   * Sidebar color
   */
  public readonly color = input<string>();
  /**
   * Tooltip title
   */
  public readonly title = input<string>();
  /**
   * Tooltip content
   */
  public readonly content = input<TTooltipChartsItem[]>([]);
  /**
   * A flag to show or hide the tooltip
   */
  public readonly show = input<boolean>(false);
  /**
   * Tooltip position
   */
  public readonly position = input<{ top: number, left: number }>({ top: 0, left: 0 });

}